module.exports = __webpack_public_path__ + "img/esteelauder_logo_footer.38ca7f22.png";